import * as ActionTypes from './ActionTypes';
import {executeRequest} from '../../dataActions/dataFetcher';
import { NotificationManager } from 'react-notifications';


export const store_Login = (payload) => {
    return {
        type: ActionTypes.CHECK_LOGIN,
        payload: payload
    }
}

export const checkLogin = (params) => async dispatch => {

    const response = await executeRequest('login/fetchPermission', params, dispatch)

    if(!!response) {
        let data = {
            ...response,
            loggedInEmail: params.email
        };
        dispatch(store_Login(data));
        return;
    }

    NotificationManager.error("Käyttäjä / salasana ei täsmää", "", 3000);
}

export const checkExisting = params => async dispatch => {
    const response = await executeRequest('login/authCheck', params, dispatch)

    if(!!response) {
        dispatch(store_Login({isAuthenticated: true}));
        return true;
    }

    return false;
}

export const onCodeLogin = (data) => {
    return {
      type: ActionTypes.CODE_LOGIN,
      payload: data
    }
}

export const codeLogin = (codeObj) => async dispatch => {

    const response = await executeRequest('login/codeLogin', codeObj, dispatch)

    if(response.jwtToken) {
        window.sessionStorage.setItem("token", response.jwtToken);
        dispatch(onCodeLogin({isAuthenticated: true}));
    } else {
        NotificationManager.error("Koodi oli väärin", "Virhe", 3000);
    }
    
  }
  

export const authFailed = payload => {
    window.sessionStorage.removeItem("token");
    return {
        type: ActionTypes.AUTH_FAILED,
        payload: {
            isAuthenticated: false,
            authenticationFailed: true,
            loginSuccess: false
        }
    }
}